export function paygClientRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "GET_PAYG_CLIENTS_START":           
        case "GET_PAYG_SELECTED_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "GET_PAYG_CLIENTS_FULFILLED":           
        case "GET_PAYG_SELECTED_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "GET_PAYG_CLIENTS_ERROR":
        case "GET_PAYG_SELECTED_ERROR": {
            const err = payload == null ? null : (typeof payload === 'string' ? payload : (payload?.message ?? String(payload)));
            return {
                ...state,
                fetching: false,
                error: err
            };
        }
        default:
            return state;
    }
    
}